export default "__VITE_ASSET__Bw2p4h52__"